import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
var __default__ = defineComponent({
  head: {}
});
import { PAGE_PARAM_NAME } from '~/constants';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import useLegacySeoMeta from '~/composables/useLegacySeoMeta';
export default /*#__PURE__*/_defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  __name: 'AzPagination',
  props: {
    numberOfPages: {
      default: 0
    },
    numberOfPagesVisible: {
      default: 4
    },
    current: {
      default: 1
    },
    paramNamesToKeep: {
      default: function _default() {
        return [];
      }
    },
    addSeoLinks: {
      type: Boolean,
      default: true
    }
  },
  emits: ['change-page'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var route = useRoute();
    var router = useRouter();
    var _useLegacySeoMeta = useLegacySeoMeta(),
      cleanQuery = _useLegacySeoMeta.cleanQuery,
      getPaginationMetaLinks = _useLegacySeoMeta.getPaginationMetaLinks;
    if (props.addSeoLinks) {
      useMeta({
        link: _toConsumableArray(getPaginationMetaLinks(props.numberOfPages))
      });
    }

    /**
     * Push the new page to the router
     *
     * @param      {number}  pageNumber  The page number
     */
    function changePage(pageNumber) {
      var queryPage = pageNumber !== 1 ? pageNumber : 1;
      var query = cleanQuery(route.query, new Set(props.paramNamesToKeep));
      query[PAGE_PARAM_NAME] = queryPage;
      if (queryPage === 1) {
        var pageParamRegex = new RegExp("[?|&]".concat(PAGE_PARAM_NAME, "=\\d"), '');
        var routeWithoutPageQuery = route.fullPath.replace(pageParamRegex, '');
        router.push(routeWithoutPageQuery);
        delete query[PAGE_PARAM_NAME];
      }
      if (queryPage > 1) {
        router.push({
          query: _objectSpread(_objectSpread({}, query), {}, _defineProperty({}, PAGE_PARAM_NAME, queryPage))
        });
      }
      emit('change-page', queryPage);
    }

    /**
     * Gets the link to the given page.
     *
     * @param      {(number|string)}         page    The page
     * @return     {(Object|number|string)}  The link to.
     */
    function getLinkTo(page) {
      var pageNumber = page.toString();
      if (router) {
        var queryPage = page !== 1 ? page : undefined;
        var query = cleanQuery(route.query, new Set(props.paramNamesToKeep));
        query[PAGE_PARAM_NAME] = queryPage;
        if (!queryPage) {
          delete query[PAGE_PARAM_NAME];
        }
        return _objectSpread(_objectSpread({}, route), {}, {
          query: query
        });
      } else if (pageNumber) {
        return pageNumber;
      }
    }
    var currentPage = computed(function () {
      return route ? route.query[PAGE_PARAM_NAME] ? parseInt(route.query[PAGE_PARAM_NAME]) : 1 : props.current;
    });
    var listOfPageNumbers = computed(function () {
      return Array.from(Array(props.numberOfPages || 0), function (_, i) {
        return i + 1;
      });
    });
    var limitedPageNumbers = computed(function () {
      if (props.numberOfPages <= props.numberOfPagesVisible) {
        return listOfPageNumbers.value;
      }
      if (currentPage.value < props.numberOfPagesVisible - Math.floor(props.numberOfPagesVisible / 2) + 1) {
        return listOfPageNumbers.value.slice(0, props.numberOfPagesVisible);
      }
      if (props.numberOfPages - currentPage.value < props.numberOfPagesVisible - Math.ceil(props.numberOfPagesVisible / 2) + 1) {
        return listOfPageNumbers.value.slice(props.numberOfPages - props.numberOfPagesVisible);
      }
      return listOfPageNumbers.value.slice(currentPage.value - Math.ceil(props.numberOfPagesVisible / 2), currentPage.value + Math.floor(props.numberOfPagesVisible / 2));
    });
    var firstVisiblePageNumber = computed(function () {
      return limitedPageNumbers.value[0];
    });
    var lastVisiblePageNumber = computed(function () {
      return limitedPageNumbers.value[limitedPageNumbers.value.length - 1];
    });
    var getPrev = computed(function () {
      return currentPage.value === firstVisiblePageNumber.value ? currentPage.value : currentPage.value - 1;
    });
    var canGoPrev = computed(function () {
      return currentPage.value !== firstVisiblePageNumber.value;
    });
    var getNext = computed(function () {
      return currentPage.value === lastVisiblePageNumber.value ? currentPage.value : currentPage.value + 1;
    });
    var canGoNext = computed(function () {
      return currentPage.value !== lastVisiblePageNumber.value;
    });
    var showFirst = computed(function () {
      return firstVisiblePageNumber.value > 1;
    });
    var showLast = computed(function () {
      return lastVisiblePageNumber.value < props.numberOfPages;
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      route: route,
      router: router,
      cleanQuery: cleanQuery,
      getPaginationMetaLinks: getPaginationMetaLinks,
      changePage: changePage,
      getLinkTo: getLinkTo,
      currentPage: currentPage,
      listOfPageNumbers: listOfPageNumbers,
      limitedPageNumbers: limitedPageNumbers,
      firstVisiblePageNumber: firstVisiblePageNumber,
      lastVisiblePageNumber: lastVisiblePageNumber,
      getPrev: getPrev,
      canGoPrev: canGoPrev,
      getNext: getNext,
      canGoNext: canGoNext,
      showFirst: showFirst,
      showLast: showLast,
      AzIcon: AzIcon,
      AzButton: AzButton
    };
  }
}));